import { useContext } from "react";
import { Box, Button, Card, CardActionArea, Divider, Tooltip } from "@mui/material";
import { AddComment, Task } from "@mui/icons-material";
import { P } from "theme/typography";
import { displayDateAndTimeCompact } from "Backend";
import { AnnotationsContext } from "contexts/AnnotationsContext";

const AnnotationMenu = () => {
  const { setAnnotationEditorOpen, drawing, documentAnnotations, setSelectedDocumentAnnotation, findCreatorName } =
    useContext(AnnotationsContext);
  return (
    <Box
      sx={{
        width: "280px",
        display: "flex",
      }}>
      <Divider orientation="vertical" />
      <Box sx={{ width: "280px", backgroundColor: "grey.50", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "white",
            py: 1,
            px: 2,
          }}>
          <P variant="lgBold">Annotations</P>
          <Box
            sx={{
              display: "flex",
            }}>
            <Button
              data-pendo="document-viewer-new-annotation-button"
              onClick={() => {
                setAnnotationEditorOpen(true);
                drawing.setEnabled(true);
              }}
              sx={{
                display: "flex",
                gap: 1,
                alignItems: "center",
                justifyContent: "center",
              }}
              variant="contained"
              size="small">
              New
              <AddComment />
            </Button>
          </Box>
        </Box>
        <Divider />
        <Box
          sx={{
            overflowY: "auto",
            flex: 1,
          }}>
          {/* Annotation List */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              p: 1,
              mb: 8,
            }}
            onMouseLeave={() => {
              setSelectedDocumentAnnotation(undefined);
            }}>
            {documentAnnotations.map((annotation) => {
              return (
                <Card
                  key={annotation.id}
                  variant="outlined"
                  onMouseOver={() => {
                    setSelectedDocumentAnnotation(annotation);
                  }}
                  onClick={() => setAnnotationEditorOpen(true)}>
                  <CardActionArea
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      gap: 4,
                      p: 2,
                    }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 0.5,
                      }}>
                      <Box sx={{ whiteSpace: "pre-wrap" }}>
                        <P
                          variant="xs"
                          sx={{
                            display: "-webkit-box",
                            WebkitLineClamp: 3,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                          }}>
                          {annotation.note}
                        </P>
                      </Box>
                      <P
                        variant="xs"
                        sx={{
                          color: "grey.500",
                        }}>
                        {findCreatorName(annotation) || ""} at{" "}
                        {annotation.editedAt
                          ? displayDateAndTimeCompact(annotation.editedAt)
                          : displayDateAndTimeCompact(annotation.createdAt)}
                      </P>
                    </Box>
                    {annotation.exportInclude && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                        }}>
                        <Tooltip title="Included in Exports" arrow>
                          <Task
                            sx={{
                              color: "grey.200",
                            }}
                          />
                        </Tooltip>
                      </Box>
                    )}
                  </CardActionArea>
                </Card>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AnnotationMenu;
